<template>
  <div :class="`carousel${carouselStyle ? ` ${carouselStyle}` : ''}`" ref="scrollList">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { defineComponent, onMounted, reactive, ref } from 'vue'

defineComponent({
  name: 'CarouselComponent'
})
defineProps({
  carouselStyle: { type: String, default: '', required: false }
})
const scrollList = ref(null)
const scrollState = reactive({
  items: [],
  state: 'start'
})

const setChildRef = refs => {
  scrollState.items = refs.value
}

defineExpose({
  scrollState,
  setChildRef,
  getScrollList: () => scrollList
})

onMounted(() => {
  scrollList.value.addEventListener('scroll', e => {
    const scrollWidth = e.target.scrollWidth
    const scrollLeft = e.target.scrollLeft
    const width = e.target.offsetWidth
    const offsetRight = Math.floor(scrollWidth - scrollLeft - width)

    if (!scrollLeft) {
      scrollState.state = 'start'
    } else if (!offsetRight || offsetRight <= 0) {
      scrollState.state = 'end'
    } else {
      scrollState.state = 'mid'
    }
  })
})
</script>

<style lang="scss">
.carousel {
  display: flex;
  scroll-snap-type: x mandatory;
  scroll-behavior: smooth;
  overflow: auto;

  &::-webkit-scrollbar {
    display: none;
  }
}
</style>
